"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTheme_1 = require("./getTheme");
var lightTheme = getTheme_1.default({ themeName: "light" });
exports.default = lightTheme;
//# sourceMappingURL=lightTheme.js.map